import moment from "moment";

function GetTimeStamp() {
  const currentTime = moment().format("YYYY/MM/DD HH:mm:ss");
  return currentTime;
}

function GetCurrentTime() {
  const currentTime = moment();
  return currentTime;
}

function Get30Days() {
  const priorDate2 = moment().add(30, "days");
  return priorDate2;
}

export { GetTimeStamp, Get30Days, GetCurrentTime };
